import Vue from 'vue'

/* iview 框架引用 */
// import iView from 'iview';
// import 'iview/dist/styles/iview.css';
// Vue.use(iView);
import iView from 'iview'
import '../my-theme/index.less'
Vue.use(iView)


// WEBPACK FOOTER //
// ./src/ui.js